export * from './useResource2';
